/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Per-pack seed: each esbuild pack loads its own copy of this module and
// picks its own seed, so popoverIds don't collide when (e.g.) the navbar
// pack and the project_component pack both render UserBadges on the same
// page. Combined with this._uid for per-instance uniqueness within a pack.
const moduleSeed = crypto.randomUUID().slice(0, 8);

const __vue_script__ = {
  name: "UserBadge",
  props: {
    name: { type: String, default: null },
    email: { type: String, default: null },
    role: { type: String, default: null },
    avatarUrl: { type: String, default: null },
    variant: { type: String, default: "secondary" },
    size: { type: String, default: null },
    showName: { type: Boolean, default: false },
  },
  computed: {
    popoverId() {
      return `user-badge-${moduleSeed}-${this._uid}`;
    },
    displayName() {
      return this.name || this.email || null;
    },
    initials() {
      if (this.name && this.name.trim()) {
        const parts = this.name.trim().split(/\s+/);
        if (parts.length >= 2) {
          return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return parts[0][0].toUpperCase();
      }
      if (this.email && this.email.trim()) {
        return this.email.trim().slice(0, 2).toUpperCase();
      }
      return null;
    },
    hasPopoverContent() {
      if (this.email) return true;
      if (this.role) return true;
      if (!this.showName && this.displayName) return true;
      return false;
    },
    popoverContent() {
      const lines = [];
      if (!this.showName && this.displayName) lines.push(this.displayName);
      if (this.email) lines.push(this.email);
      if (this.role) lines.push(`Role: ${this.role}`);
      return lines.join("\n");
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "user-badge d-inline-flex align-items-center",
      attrs: { id: _vm.popoverId },
    },
    [
      _c("b-avatar", {
        staticClass: "flex-shrink-0",
        attrs: {
          text: _vm.initials || undefined,
          src: _vm.avatarUrl || undefined,
          icon: !_vm.initials && !_vm.avatarUrl ? "person-fill" : undefined,
          variant: _vm.variant,
          size: _vm.size,
        },
      }),
      _vm._v(" "),
      _vm.showName && _vm.displayName
        ? _c("span", { staticClass: "user-badge__name ml-1" }, [
            _vm._v("\n    " + _vm._s(_vm.displayName) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPopoverContent
        ? _c(
            "b-popover",
            {
              attrs: {
                target: _vm.popoverId,
                container: "body",
                triggers: "hover focus",
                placement: "top",
                delay: { show: 300, hide: 100 },
              },
            },
            [
              _c("div", { staticClass: "user-badge__popover" }, [
                !_vm.showName
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.displayName || "Unknown user")),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.email
                  ? _c("div", { staticClass: "small" }, [
                      _vm._v(_vm._s(_vm.email)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.role
                  ? _c("div", { staticClass: "small" }, [
                      _vm._v("Role: " + _vm._s(_vm.role)),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-02ced350_0", { source: "\n.user-badge[data-v-02ced350] {\n  cursor: default;\n}\n.user-badge__name[data-v-02ced350] {\n  font-size: 0.875rem;\n}\n", map: {"version":3,"sources":["app/javascript/components/shared/UserBadge.vue"],"names":[],"mappings":";AAsFA;EACA,eAAA;AACA;AAEA;EACA,mBAAA;AACA","file":"UserBadge.vue","sourcesContent":["<template>\n  <span :id=\"popoverId\" class=\"user-badge d-inline-flex align-items-center\">\n    <b-avatar\n      :text=\"initials || undefined\"\n      :src=\"avatarUrl || undefined\"\n      :icon=\"!initials && !avatarUrl ? 'person-fill' : undefined\"\n      :variant=\"variant\"\n      :size=\"size\"\n      class=\"flex-shrink-0\"\n    />\n    <span v-if=\"showName && displayName\" class=\"user-badge__name ml-1\">\n      {{ displayName }}\n    </span>\n    <b-popover\n      v-if=\"hasPopoverContent\"\n      :target=\"popoverId\"\n      container=\"body\"\n      triggers=\"hover focus\"\n      placement=\"top\"\n      :delay=\"{ show: 300, hide: 100 }\"\n    >\n      <div class=\"user-badge__popover\">\n        <strong v-if=\"!showName\">{{ displayName || \"Unknown user\" }}</strong>\n        <div v-if=\"email\" class=\"small\">{{ email }}</div>\n        <div v-if=\"role\" class=\"small\">Role: {{ role }}</div>\n      </div>\n    </b-popover>\n  </span>\n</template>\n\n<script>\n// Per-pack seed: each esbuild pack loads its own copy of this module and\n// picks its own seed, so popoverIds don't collide when (e.g.) the navbar\n// pack and the project_component pack both render UserBadges on the same\n// page. Combined with this._uid for per-instance uniqueness within a pack.\nconst moduleSeed = crypto.randomUUID().slice(0, 8);\n\nexport default {\n  name: \"UserBadge\",\n  props: {\n    name: { type: String, default: null },\n    email: { type: String, default: null },\n    role: { type: String, default: null },\n    avatarUrl: { type: String, default: null },\n    variant: { type: String, default: \"secondary\" },\n    size: { type: String, default: null },\n    showName: { type: Boolean, default: false },\n  },\n  computed: {\n    popoverId() {\n      return `user-badge-${moduleSeed}-${this._uid}`;\n    },\n    displayName() {\n      return this.name || this.email || null;\n    },\n    initials() {\n      if (this.name && this.name.trim()) {\n        const parts = this.name.trim().split(/\\s+/);\n        if (parts.length >= 2) {\n          return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();\n        }\n        return parts[0][0].toUpperCase();\n      }\n      if (this.email && this.email.trim()) {\n        return this.email.trim().slice(0, 2).toUpperCase();\n      }\n      return null;\n    },\n    hasPopoverContent() {\n      if (this.email) return true;\n      if (this.role) return true;\n      if (!this.showName && this.displayName) return true;\n      return false;\n    },\n    popoverContent() {\n      const lines = [];\n      if (!this.showName && this.displayName) lines.push(this.displayName);\n      if (this.email) lines.push(this.email);\n      if (this.role) lines.push(`Role: ${this.role}`);\n      return lines.join(\"\\n\");\n    },\n  },\n};\n</script>\n\n<style scoped>\n.user-badge {\n  cursor: default;\n}\n\n.user-badge__name {\n  font-size: 0.875rem;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-02ced350"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/components/shared/UserBadge.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__